module.exports = __webpack_public_path__ + "img/40.4173469d.jpg";